<template>
	
  <div class="page-task-list">
	  
	  <b-card no-body>
	    <b-card-body>
	      
	  	  <b-row>
	  	    <b-col md="4">
	  	      <b-form-group :label="$t('Status')">
				<v-select
				    v-model="filter.Status"
				    label="diagTaskStatusString"
					:reduce="diagTaskStatusString => diagTaskStatusString.diagTaskStatusId"
				    :options="taskStatus"
					:placeholder="$t('Please select')+$t('Status')"
				/>
	  	      </b-form-group>
	  	    </b-col>
	  	    <b-col md="4">
	  	      <b-form-group :label="$t('Type')">
				<v-select
				    v-model="filter.Type"
				    label="diagnosisProtocolString"
					:reduce="diagnosisProtocolString => diagnosisProtocolString.diagnosisProtocolIdentifier"
				    :options="taskType"
					:placeholder="$t('Please select')+$t('Type')"
				/>
	  	      </b-form-group>
	  	    </b-col>
	  	    <b-col md="4">
	  	      <b-form-group :label="$t('Device')">
	  	        <v-select
	  	            v-model="deviceNameList"
	  	            multiple
	  	            label="deviceIdentifier"
	  	            :options="taskDevices"
					:placeholder="$t('Please select')+$t('Device')"
	  	        />
	  	      </b-form-group>
	  	    </b-col>
	  	  
	  	  </b-row>
	  	  
	    </b-card-body>
	  </b-card>	
	  
	  <b-card no-body>
	  	<div class="m-2">
	  	
	  	  <b-row>
	  	
	  		<!-- 添加任务 -->
	  	    <b-col
	  	      cols="12"
	  	    >
	  	      <div class="d-flex align-items-center justify-content-end">
	  	        <b-button
	  	            variant="primary"
	  	            :to="{ name: 'diagnostic-task-add'}"
	  	        >
	  	          {{$t('Add Task')}}
	  	        </b-button>
	  	      </div>
	  	    </b-col>
	  	  </b-row>
	  	
	  	</div>
	  	
	  	<b-form-checkbox-group v-model="checkItems">
		  <b-table
		    :items="tasks"
		    responsive
		    :fields="columns"
		    show-empty
		    :empty-text="$t('No matching records found')"
		    class="position-relative"
			sort-icon-left
			@sort-changed="handleSortChange"
		  >
		  
		    <!-- 列: 选择框 -->
		    <template #cell(#)="data">
		        	
		      <div class="text-nowrap">
		    				
		        <b-form-checkbox
		          :value="data.item.taskId"
		        >
		        </b-form-checkbox>  	       
		      </div>
		    </template> 
		    
		    <!-- 列: 类型 -->
		    <template #cell(taskDiagnosisType)="data">
		      {{ data.item.dicDiagProtocolType.diagnosisProtocolString }}
		    </template>
		    
		    <!-- 列: Status -->
		    <template #cell(taskExecStatus)="data">
		      {{ data.item.dicDiagTaskStatus.diagTaskStatusString }}
		    </template>
		     
		  
		    <!-- 列: Actions -->
		    <template #cell(actions)="data">
		  
		      <div class="text-nowrap">
		        <!--<span
		        @click="$router.push({ name: 'diagnostic-device-edit', params: { id: data.item.deviceIdentifier }})"
		        >
		          <feather-icon
		        			class="ml-2"
		          icon="EditIcon" />
		          <span class="align-middle ml-50">Edit</span>	
		        </span>-->
		  	  <!--<b-form-checkbox
		  	    v-if="data.item.taskExecStatus == 1 || data.item.taskExecStatus == 2"
		  	    :checked="data.item.taskExecStatus == 1?true:false"
		  	    name="check-button"
		  	    switch
		  	    inline
		  		@change="onSwitch($event, data.item.taskId)"
		  		class="mr-1" 
		  	  >
		  	    {{$t("On/Off")}}
		  	  </b-form-checkbox>-->
			    <a
			    @click="$router.push({ name: 'diagnostic-task-view', params: { name: data.item.taskId }})"
			    >
			      <feather-icon
			      class="ml-2"
			      icon="EyeIcon" />
			      <span class="align-middle ml-50">{{$t("View")}}</span>	
			    </a>
		        
		        <a @click="resetTask(data.index, data.item.taskId, data.item.taskDeviceIdentifier)" >
		        	<feather-icon icon="RefreshCcwIcon" class="ml-2" />
		        	<span class="align-middle ml-50">{{$t("Reuse")}}</span>
		        </a>	 
		      </div>
		    </template>
			
			<template #head(#)="data">
			  <b-form-checkbox @change="checkAll" value="all"></b-form-checkbox> 
			</template>
		  
		  </b-table>	
	  	</b-form-checkbox-group>
		
		
		<div class="m-2">
		  <b-row>
		
			<!-- 下载 -->
		    <b-col
		      cols="12"
		    >
		      <div class="d-flex align-items-center justify-content-end">
		        <b-button
		          variant="primary"
				  @click="batchDelete()"
		        >
		          {{$t('Delete')}}
		        </b-button>
		      </div>
		    </b-col>
		  </b-row>
		</div>
	  	
	  	
	  	
	  	<div class="mx-2 mb-2">
	  	    <b-row>
	  	      <!-- 页码 -->
	  	      <b-col
	  	        cols="12"
	  	        sm="12"
	  	        class="d-flex align-items-center justify-content-center justify-content-sm-start"
	  	      >
	  	
	  	        <b-pagination
	  	          v-model="filter.Page"
	  	          :total-rows="total"
	  	          :per-page="filter.Size"
	  	          first-number
	  	          last-number
	  	          class="mb-0 mt-1 mt-sm-0"
	  	          prev-class="prev-item"
	  	          next-class="next-item"
				  @change="onClickPage"
	  	        >
	  	          <template #prev-text>
	  	            <feather-icon
	  	              icon="ChevronLeftIcon"
	  	              size="18"
	  	            />
	  	          </template>
	  	          <template #next-text>
	  	            <feather-icon
	  	              icon="ChevronRightIcon"
	  	              size="18"
	  	            />
	  	          </template>
	  	        </b-pagination>
	  	
	  	      </b-col>
	  	
	  	    </b-row>
	  	</div>
	  	
	  
	  
	  </b-card>
	  
	  <b-modal
	    id="modal-reset"
	    hide-footer
	    :title="$t('Reuse')"
	    :ok-title="$t('Submit')"
	  	centered
	  >
	    <b-form-group :label="$t('If replacing the device, please select')">
	      <v-select
	          v-model="resetDevice"
	          label="deviceIdentifier"
	          :options="taskOnlineDevices"
	      />
	    </b-form-group>
		<b-button class="mt-3" variant="outline-danger" block @click="onReset">{{$t('Submit')}}</b-button>
	    <b-button class="mt-2" variant="outline-warning" block @click="onCloseReset">{{$t('Close')}}</b-button>
	    
	  </b-modal>
  </div>
	
</template>

<script>
import {
  BFormCheckbox, BFormCheckboxGroup, BCard, BCardHeader, BCardBody, BTable, BLink, BDropdown, BDropdownItem, BTooltip, BAvatar, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol,BButton
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import vSelect from 'vue-select'
import { getTaskTypes, getTaskStatus, getTaskDevices, getTasks, delTasks, startTask, stopTask, resetTask } from '@/api/task'
import { getUserData } from '@/utils/auth'
import { getToken } from '@/utils/auth'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
	BFormCheckbox,
	BFormCheckboxGroup,
	BCard, 
	BCardHeader, 
	BCardBody,
	BTable, 
	BLink, 
	BDropdown, 
	BDropdownItem, 
	BTooltip, 
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    ToastificationContent,
    vSelect,
  },
  data() {
    return {
      //任务类型列表
      taskType: [],
      //任务状态列表
      taskStatus: [],
	  //任务设备
	  taskDevices:[],
	  //在线任务设备
	  taskOnlineDevices:[],
      //在线任务设备初始化
      taskOnlineDevicesInit:[],
      //任务列表
      tasks:[],
	  //总数量
	  total:0,
	  //任务筛选
      filter:{
        Page:1,
        Size:20,
        DeviceNameList:null,
        Status:null,
        Type:null,
		IsDesc:true,
		PropertyName:'taskId'
      },
	  deviceNameList:null,
      columns: [
		'#',  
		{ key: 'taskId', label: this.$t('Task id'), sortable: true },
		{ key: 'taskName', label: this.$t('Task Name'), sortable: true },
		{ key: 'taskDeviceIdentifier', label: this.$t('Device'), sortable: true },
		{ key: 'taskDescirption', label: this.$t('Task Description'), sortable: true },
		{ key: 'taskDiagnosisType', label: this.$t('Type'), sortable: true },
		{ key: 'taskExecStatus', label: this.$t('Status'), sortable: true },
		{ key: 'taskExecStatus', label: this.$t('Status'), sortable: true },
		{ key: 'createTime', label: this.$t('Create Time'), sortable: true },
		{ key: 'actions', label: this.$t('Actions') }
      ],
      //用户信息
      userData:{
        role:null,  
      },
	  //选中项
	  checkItems:[],
	  //是否全选
	  isCheckAll:false,
	  //当前选中任务序号
	  activeIndex:null,
	  //当前选中任务名称
	  activeName:null,
	  //任务重置更改设备名称
	  resetDevice:null,
	  
	  socket: null,
	  connectionStatus: 'Disconnected'
    }
  },
  created() {
    this.getTaskTypes()
    this.getTaskStatus()
    this.getTaskDevices()
	this.getTaskOnlineDevices()
	this.userData = getUserData()
	if(this.$route.params.deviceName){
	  this.filter.DeviceNameList = this.$route.params.deviceName
	  this.deviceNameList = this.$route.params.deviceName
	}
	this.getTasks(this.filter)
	
	this.socket = new WebSocket($themeConfig.app.socketUrl + "?token=Bearer " + getToken());
		
	// 监听 WebSocket 连接事件
	this.socket.onopen = () => {
	  this.connectionStatus = 'Connected';
	};
		
	// 监听 WebSocket 消息事件
	this.socket.onmessage = (event) => {
	  let serverData = JSON.parse(event.data);
	    if(serverData.Message=="TASK_INSERT"){
		  this.$toast({
		    component: ToastificationContent,
			osition: 'top-right',
			props: {
			  title: this.$t('New Tasks'),
			  icon: 'CoffeeIcon',
			  variant: 'success',
			  text: serverData.Data.FromDeviceIdentifier,
			},
		  })
		}
		else if(serverData.Message=="TASK_UPDATE"){
		  const itemIndex = this.tasks.findIndex((item) => item.taskId === serverData.Data.taskId);
		  if (itemIndex !== -1) {
		    this.$set(this.tasks, itemIndex, serverData.Data);
		  }  
		}
	  };
	
	  // 监听 WebSocket 断开连接事件
	  this.socket.onclose = () => {
	    this.connectionStatus = 'Disconnected';
	  };
	
  },
  methods: {
	  
    //获取任务类型列表
    getTaskTypes(){
      getTaskTypes().then(response => {
		this.taskType = response.data  
      })
    },
    //获取任务状态列表
    getTaskStatus(){
      getTaskStatus().then(response => {
		this.taskStatus = response.data 
      })
    },
    //获取任务设备列表
    getTaskDevices(){
      getTaskDevices().then(response => {
        this.taskDevices = response.data.map(item => item.deviceIdentifier)
      })
    },
	//获取在线任务设备列表
	getTaskOnlineDevices(){
	  getTaskDevices().then(response => {
	    this.taskOnlineDevices = response.data.map(item => item.deviceIdentifier)
		this.taskOnlineDevicesInit = this.taskOnlineDevices
	  })
	},

    //获取任务列表
    getTasks(){
      getTasks(this.filter).then(response => {
        this.tasks = response.data
		this.total = response.count
      })
    },
	//点击分页
	onClickPage(page){
	  this.filter.Page = page
	  this.getTasks()
	},
	//任务开关
	/*onSwitch(e, name){
	  if(e){
	    this.startTask(name)
	  }
	  else{
	    this.stopTask(name)
	  }
	},*/
	//开始任务
	/*startTask(id){
	  startTask(id).then(response => {
	  })
	},*/
	//结束任务
	/*stopTask(id){
	  stopTask(id).then(response => {
	  })
	},*/
    //删除任务
    /*onClickDel(index, name){  
      this.$bvModal
        .msgBoxConfirm(this.$t('Please confirm will delete?'), {
          size: 'sm',
          okVariant: 'primary',
          okTitle: this.$t('Confirm'),
          cancelTitle: this.$t('Cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
    	.then(value => {
    	  if(value){
    	    this.tasks.splice(index, 1)
    		  delTasks(name)
    		}
    	})
    	  
    },*/
	//批量删除
	batchDelete(){
	  if(this.checkItems.length<1){
		this.$toast({
		  component: ToastificationContent,
		  position: 'top-right',
		  props: {
		    title: this.$t('Please select'),
		    icon: 'CoffeeIcon',
		    variant: 'danger',
		  },
		})
		return false
	  
	  }	
	  this.$bvModal
	    .msgBoxConfirm(this.$t('Please confirm will delete?'), {
	      size: 'sm',
	      okVariant: 'primary',
	      okTitle: this.$t('Confirm'),
	      cancelTitle: this.$t('Cancel'),
	      cancelVariant: 'outline-secondary',
	      hideHeaderClose: false,
	      centered: true,
	    })
	    .then(value => {
	      if(value){
			let checkItems = this.checkItems.filter((item)=>{return item!='all'})	
			delTasks(checkItems.join(',')).then(response => {
			  this.checkItems = []	
			  this.getTasks()
			  this.$toast.success(this.$t('Delete Success'))
			})
	      }
	    })
			
	},  
	//重置任务
	resetTask(index, name, deviceName){
	  this.activeIndex = index
	  this.activeName = name		
	  this.taskOnlineDevices = this.taskOnlineDevicesInit.filter((item)=>{return item!=deviceName});
	  this.taskOnlineDevices.unshift(deviceName)
	  this.resetDevice = deviceName
      this.$bvModal.show('modal-reset')
    },
	//弹窗重置提交
	onReset(){
	  this.$bvModal
	    .msgBoxConfirm(this.$t('Please confirm will reuse'), {
	      size: 'sm',
	      okVariant: 'primary',
	      okTitle: this.$t('Confirm'),
	      cancelTitle: this.$t('Cancel'),
	      cancelVariant: 'outline-secondary',
	      hideHeaderClose: false,
	      centered: true,
	    })
		.then(value => {
		  if(value){
		  	resetTask(this.activeName, {deviceIdentifier: this.resetDevice}).then(response => {
			  //this.tasks.splice(this.activeIndex,1,response.data)
			  this.filter.Page = 1
			  this.getTasks()
			  this.resetDevice = null
			  this.$bvModal.hide('modal-reset')
			  this.$toast.success(this.$t('Operation Success'))
				  
		    })
		  }	
	    })  		
	},
	//弹窗重置关闭
	onCloseReset(){
	  this.$bvModal.hide('modal-reset')	
	},
	//全选
	checkAll(e){
	  this.isCheckAll = !this.isCheckAll
	  if(this.isCheckAll){
	    this.checkItems = this.tasks.map(item => item.taskId)
		this.checkItems.push('all')
	  }
	  else{
	    this.checkItems = []	  
	  }
	},
	//排序
	handleSortChange(e){
	  this.filter.PropertyName = e.sortBy
	  this.filter.IsDesc = e.sortDesc
	  this.tasks = []
	  this.getTasks(this.filter)
	},
	
	
  },
  beforeDestroy() {
    // 断开 WebSocket 连接
	this.socket.close();
  },
  watch: {
    'deviceNameList'(newValue) {
	  this.filter.DeviceNameList = newValue.join(',')
      this.getTasks(this.filter)
    },
	'filter.Status'(){
	  this.getTasks(this.filter)	
	},
	'filter.Type'(){
	  this.getTasks(this.filter)	
	},
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
[dir] .vs__dropdown-toggle {
    padding: 0 0 4px 0;
    background: none;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
}
</style>
